import { type ReactElement } from 'react'
import { Dialog, DialogContent } from 'app/components/ui/dialog'
import { ScheduleAppointmentContent } from 'app/components/scheduling/inapp/ScheduleAppointmentContent'
import type { ContactJson } from 'app/types/entities'

/**
 * Modal presentation of the in-app scheduling wizard, used by the contact drawer
 * and as the below-md fallback for the inbox dock. The wizard itself lives in
 * ScheduleAppointmentContent so both presentations share one implementation.
 */
export function ScheduleAppointmentDialog({
  contact,
  locationId,
  kollaConsumerId,
  open,
  onOpenChange,
}: {
  contact: ContactJson
  locationId: string
  kollaConsumerId?: string
  open: boolean
  onOpenChange: (open: boolean) => void
}): ReactElement {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Flex column with a bounded height: the header, provider notice, and
          wizard buttons stay anchored while the step content scrolls. */}
      <DialogContent className="flex max-h-[calc(100dvh-2rem)] max-w-3xl flex-col">
        <ScheduleAppointmentContent
          contact={contact}
          locationId={locationId}
          kollaConsumerId={kollaConsumerId}
          active={open}
          showHeader
          titleAsDialogTitle
        />
      </DialogContent>
    </Dialog>
  )
}
